(() => {
  if (window.GateDropCart) return;
  let pending;
  const fallback = () => location.assign((window.Shopify?.routes?.root || '/') + 'cart');
  const timeout = promise => Promise.race([promise, new Promise((_, reject) => setTimeout(() => reject(new Error('Cart timeout')), 6000))]);
  window.GateDropCart = {
    open() {
      if (pending) return pending;
      pending = (async () => {
        try {
          const deadline = Date.now() + 2500;
          while (!window.Instant?.api && Date.now() < deadline) await new Promise(resolve => setTimeout(resolve, 100));
          const api = window.Instant?.api;
          if (!api || !document.querySelector('[data-instant-layout="CART"]')) { fallback(); return; }
          await timeout(api.updateCart());
          api.toggleCart(true);
          fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials: 'same-origin'})
            .then(response => response.ok ? response.json() : null)
            .then(cart => { if (cart) document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart}})); })
            .catch(() => {});
        } catch (_) { fallback(); }
        finally { pending = null; }
      })();
      return pending;
    }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-gd-instant-cart]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.GateDropCart.open();
  }, true);
})();
